import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const AddressContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  height: "100%",
  padding: "0px 0px",
  marginTop: "2%",
  marginBottom: "2%",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "center",
    margin: "2%",
  },
}));

export const AddressContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  maxWidth: 420,
  padding: "30px",
  marginLeft: "10%",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    margin: "3%",
  },
}));

export const AddressImage = styled("img")(({ src, theme }) => ({
  src: `url(${src})`,
  width: "50%",
  margin: "2%",

  [theme.breakpoints.down("md")]: {
    margin: "2%",
    width: "350px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "320px",
    height: "300px",
    margin: "2%",
  },
}));
